import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { Translate } from '../../../../../shared/LanguageService';
import { FirmProduct } from '../types';
import { ProductCard } from './ProductCard';

type FloorPlansStepProps = {
    floorPlans: FirmProduct[];
    chosenFloorPlanIds: number[];
    existingPlanOrderId: number | null;
    upload: React.ReactNode;
    onToggleFloorPlan: (productId: number) => void;
};

export function FloorPlansStep({
    floorPlans,
    chosenFloorPlanIds,
    existingPlanOrderId,
    upload,
    onToggleFloorPlan
}: FloorPlansStepProps) {
    if (existingPlanOrderId !== null) {
        return (
            <Link target="_blank" to={`/orders/${existingPlanOrderId}`}>
                {Translate('orders/create/plan-order-exists')}
            </Link>
        );
    }

    if (floorPlans.length === 0) {
        return <Typography>{Translate('order/create/v2/step/floor-plans/none')}</Typography>;
    }

    return (
        <Box sx={{ display: 'grid', gap: '16px' }}>
            {floorPlans.map((floorPlan) => (
                <ProductCard
                    key={floorPlan.id}
                    product={floorPlan}
                    chosen={chosenFloorPlanIds.includes(floorPlan.id)}
                    choice="many"
                    locked={floorPlan.required}
                    onChoose={() => onToggleFloorPlan(floorPlan.id)}
                />
            ))}
            {chosenFloorPlanIds.length > 0 && upload}
        </Box>
    );
}
